<template>
  <div class="companys-section">
    <x-table
      :title="$t('ui.company.title')"
      :emptyStateLabel="$t('ui.company.empty_state_label')"
      :columns="columns"
      :tableData="companies"
      :enableSearch="true"
      :searchKeywords="searchKeywords"
      @updateSearch="updateSearch"
      :totalResults="totalCount"
      :pagination="defaultPagination"
      @updatePagination="updatePagination"
      @fetchData="fetchData"
      :showLoader="loading"
      @clickCell="clickCell"
      @emitTotalTableCount="emitTotalTableCount"
      :tableSettingsName="'companies'"
      :rowsPerPage="[5, 7, 10, 15, 25, 50]"
    ></x-table>
  </div>
</template>

<script>
import Vue from "vue";
import Api from "@/api/Company";
import Modal from "@/components/helpers/Layout/NewModal.vue";
import i18n from "@/i18n";
import iconCompany from "@/assets/company.svg";
import CompanyCreate from "@/components/pages/companies/CompanyEdit.vue";
import XTable from "@/components/helpers/DataDisplay/XTable";
import Permission from "@/classes/Permission";

export default {
  components: { XTable, Modal, CompanyCreate },
  props: {
    refresh: {
      type: [Number, Boolean],
      default: 0
    }
  },
  data() {
    return {
      companies: [],
      company: {},
      Api: new Api(),
      searchKeywords: "",
      loading: false,
      totalCount: 0,
      defaultPagination: {},
      columns: [
        {
          name: "name",
          field: company => company.name,
          label: i18n.t("ui.company.columns.name"),
          required: true,
          isLink: true,
          isBold: true,
          hideByDefault: false,
          icon: iconCompany
        },
        {
          name: "id",
          label: i18n.t("ui.company.columns.id"),
          field: company => company.id,
          credentials: "root",
          hideByDefault: Permission.isRoot() ? false : true
        },
        {
          name: "website",
          label: i18n.t("ui.company.columns.website"),
          field: company => company.website,
          isLink: true,
          isUrl: true,
          hideByDefault: false
        },
        {
          name: "created_at",
          field: company => company.created_at,
          label: i18n.t("ui.company.columns.created"),
          type: "dateTime",
          hideByDefault: false
        },
        {
          name: "updated_at",
          field: company => company.updated_at,
          type: "dateTime",
          label: i18n.t("ui.company.columns.updated"),
          hideByDefault: false
        }
      ]
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    updatePagination(pagination) {
      // We just respond to the updatePagination event so that we
      // get the whole default pagination, including any XTable defaults
      this.defaultPagination = pagination;
    },
    updateSearch(searchkeywords) {
      this.searchKeywords = searchkeywords;
      this.$emit("updateSearch", searchkeywords);
    },
    emitTotalTableCount(totalTableCount) {
      this.$emit("emitTotalTableCount", totalTableCount);
    },
    async fetchData(fetchParams = {}) {
      // Build the API request
      if (fetchParams.searchKeywords) {
        this.searchKeywords = fetchParams.searchKeywords;
      }

      if (
        typeof fetchParams.searchFilters == "object" &&
        fetchParams.searchFilters
      ) {
        this.searchFilters = fetchParams.searchFilters;
      }

      let request = {
        search: this.searchKeywords,
        page: this.defaultPagination.page,
        per_page: this.defaultPagination.rowsPerPage,
        sort_by: this.defaultPagination.sortBy,
        sort_order: this.defaultPagination.descending ? "DESC" : "ASC"
      };

      if (typeof fetchParams.pagination == "object" && fetchParams.pagination) {
        request.per_page = fetchParams.pagination.rowsPerPage;
        request.sort_by = fetchParams.pagination.sortBy;
        request.sort_order = fetchParams.pagination.descending ? "DESC" : "ASC";
      }

      this.loading = true;

      // Make the request
      let requestResponse = null;
      try {
        requestResponse = await this.Api.getAllCompanies(request);
      } finally {
        this.loading = false;
        this.$emit("fetchDataComplete");
      }

      // Display both the returned company page and the total number of companies
      this.companies = requestResponse.data.resources;
      this.totalCount = requestResponse.data.total_results;
    },
    clickCell(id, fieldName) {
      if (fieldName == "name") {
        this.$router.push({ path: "/company/" + id });
      }
    }
  },
  watch: {
    refresh: {
      handler() {
        this.fetchData();
      }
    }
  }
};
</script>

<style lang="sass">
.q-popover
  .company-action-delete
    color: #df6854 !important
</style>



// WEBPACK FOOTER //
// Companies.vue?8d22c284